import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDeviceDocument } from './delete.generated';

export const useDeleteDevice = (options: ApiOptions<typeof DeleteDeviceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteDeviceDocument, {
    ...useNotifications(DeleteDeviceDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.devices.delete_success'),
    }),
    update: (cache, { data }) => {
      if (data?.deleteDevice?.device == null) return;
      cache.evict({ id: cache.identify(data.deleteDevice.device) });
    },
    ...options,
  });
};
